import React from 'react';
import { Row } from 'react-bootstrap';
import { BsCash, BsCashCoin, BsCashStack } from 'react-icons/bs';
import StatCard from '../main/StatCard';
import Price from '../../components/lakeview/Price';

const PaymentTransactionStats = ({ transactions = [] }) => {
  if (!transactions?.length) return null;

  const income = transactions
    .filter((t) => t.transactionType === 'PAYMENT')
    .reduce((acc, t) => acc + parseFloat(t.amount || 0), 0);

  const expense = transactions
    .filter((t) => t.transactionType === 'REFUND')
    .reduce((acc, t) => acc + parseFloat(t.amount || 0), 0);

  return (
    <Row className="mb-4">
      <StatCard
        title="Liczba transakcji"
        value={transactions.length}
        icon={<BsCash />}
        color="primary"
      />
      <StatCard
        title="Suma wpłat"
        value={<Price count={true} value={income} />}
        icon={<BsCashCoin />}
        color="success"
      />
      <StatCard
        title="Suma wypłat"
        value={<Price count={true} value={expense} />}
        icon={<BsCashStack />}
        color="danger"
      />
    </Row>
  );
};

export default PaymentTransactionStats;
